import Layout from 'bento-ordering/base/layouts/Layout';

import {
  MENU_ORDER_SETTING,
  MENU_ITEM_DETAIL
} from 'bento-ordering/menus/constants/paths';

import OrderSettingModal from 'bento-ordering/menus/containers/OrderSettingModal';
import MenuItemDetailModal from 'bento-ordering/menus/containers/MenuItemDetailModal';

const routes = [
  {
    path: MENU_ORDER_SETTING,
    exact: true,
    Component: OrderSettingModal,
    Layout: Layout
  },
  {
    path: MENU_ITEM_DETAIL,
    exact: true,
    Component: MenuItemDetailModal,
    Layout: Layout
  }
];

export default routes;
